var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-title-bar',{attrs:{"title":_vm.title,"textColor":"#000000"}}),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.requestUrl,"width":"100%","height":_vm.iframeHeight,"frameborder":"0","scrolling":"auto"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c4532a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/result/success.vue
// module id = null
// module chunks = 